export const SET_PAGER = 'SET_PAGER'
export const SET_BODYCOMPOSITION = 'SET_BODYCOMPOSITION'
export const RESET_BODYCOMPOSITION = 'RESET_BODYCOMPOSITION'
export const SET_BODYFATCHART = 'SET_BODYFATCHART'
export const SET_BODYWEIGHTCHART = 'SET_BODYWEIGHTCHART'
export const SET_BODYCHARTS = 'SET_BODYCHARTS'
export const SET_TARGETS = 'SET_TARGETS'
export const SET_MEASUREMENTS = 'SET_MEASUREMENTS'
export const SET_INITIAL_MEASUREMENT = 'SET_INITIAL_MEASUREMENT'

export const STORE_PAGER = 'bodycomp/pager'
